var TabHistoricModule = /** @class */ (function () {
    function TabHistoricModule() {
    }
    return TabHistoricModule;
}());
export { TabHistoricModule };
